import { useRef, useState } from "react";
import { Loader2, Upload, X, FileText } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { uploadMedia, removeMedia } from "@/lib/media";

export function FileUpload({
  value,
  onChange,
  folder = "materiais",
}: {
  value: string | null | undefined;
  onChange: (url: string | null) => void;
  folder?: string;
}) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFile = async (file: File | undefined) => {
    if (!file) return;
    setUploading(true);
    try {
      const url = await uploadMedia(file, folder);
      onChange(url);
      toast.success("Arquivo enviado com sucesso");
    } catch (err: any) {
      toast.error(err?.message ?? "Falha ao enviar arquivo");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const handleRemove = async () => {
    if (value) {
      try {
        await removeMedia(value);
      } catch {
        // ignore
      }
    }
    onChange(null);
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      {value ? (
        <span className="inline-flex max-w-[240px] items-center gap-2 rounded-md border border-border bg-muted px-3 py-1.5 text-xs text-muted-foreground">
          <FileText className="size-4 shrink-0" />
          <a href={value} target="_blank" rel="noreferrer" className="truncate hover:underline">
            Arquivo enviado
          </a>
          <button type="button" onClick={handleRemove} aria-label="Remover arquivo">
            <X className="size-3" />
          </button>
        </span>
      ) : null}
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={uploading}
        onClick={() => inputRef.current?.click()}
      >
        {uploading ? <Loader2 className="mr-2 size-4 animate-spin" /> : <Upload className="mr-2 size-4" />}
        {value ? "Trocar arquivo" : "Enviar arquivo"}
      </Button>
    </div>
  );
}
